import React, { useState } from 'react'
import { Modal, Table } from 'semantic-ui-react'
import _ from 'lodash'
import { Close } from 'components/Icons'
import localization from './localization'
import { useTheme } from 'contexts/ThemeProvider'
import themeStyles from './styles'
import TrendLine from '@web/components/TrendLine'
import Loading from 'components/Loading'
import NoData from 'containers/MyHealth/components/MyHealthContentArea/NoDataAvailableBar'
import withLocalization from '@web/helpers/localizationUtils'

const HistoryResults = ({
  data,
  title,
  onClose,
  onClick,
  loading,
  error,
  needShowTrendLine,
  t
}) => {
  const [open, setOpen] = useState(false)
  const { theme } = useTheme()
  const styles = themeStyles(theme)
  const historyError = error

  const isEmptyRange = value => _.isNil(value) || value === ''
  const getRange = item => {
    if (item?.textRange) {
      return item?.textRange
    }
    if (item?.range && !isEmptyRange(item?.low) && !isEmptyRange(item?.high)) {
      return item?.range
    }
    return null
  }

  const DataList = ({ data }) => {
    return (
      <Table
        celled
        style={styles.tableContainer(needShowTrendLine)}
        unstackable
      >
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell style={styles.tableHeader}>
              {t('date')}
            </Table.HeaderCell>
            <Table.HeaderCell style={styles.tableHeader}>
              {t('value')}
            </Table.HeaderCell>
            <Table.HeaderCell style={styles.tableHeader}>
              {t('normalRange')}
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body style={styles.tableContent}>
          {data.map((item, index) => {
            const isInRange = item.textRange
              ? item.isNormal === 'Normal'
              : item.result >= item.low && item.result <= item.high
            return (
              <Table.Row style={styles.table} key={index}>
                <Table.Cell style={styles.tableCell}>{item.date}</Table.Cell>
                <Table.Cell
                  style={{ ...styles.tableCell, ...styles.result(isInRange) }}
                >
                  {item.result}
                </Table.Cell>
                <Table.Cell style={styles.tableCell}>
                  {getRange(item)}
                </Table.Cell>
              </Table.Row>
            )
          })}
        </Table.Body>
      </Table>
    )
  }

  const handleClose = () => {
    setOpen(false)
    if (onClose) {
      onClose()
    }
  }

  const handleOpen = () => {
    setOpen(true)
    if (onClick) {
      onClick()
    }
  }

  const TriggerButton = () => {
    return (
      <div tabIndex='0' onClick={handleOpen} style={styles.triggerButton}>
        {`${t('findTrendLine')} >`}
      </div>
    )
  }

  return (
    <>
      <TriggerButton />
      <Modal
        open={open}
        onClose={handleClose}
        className='modalCentered'
        style={styles.modal}
      >
        <Modal.Header style={styles.header}>
          <div>{title}</div>
          <Close
            color={theme.primary}
            style={styles.closeIcon}
            onClick={handleClose}
          />
        </Modal.Header>
        <Modal.Content style={styles.content}>
          {!loading &&
            _.isEmpty(data) &&
            (historyError ? (
              <div style={styles.errorContainer}>
                <p style={styles.errorText}>{t('somethingWentWrong')}</p>
              </div>
            ) : (
              <div style={styles.noDataContainer}>
                <NoData />
              </div>
            ))}
          {loading ? (
            <div style={styles.container}>
              <Loading />
            </div>
          ) : (
            !_.isEmpty(data) && (
              <>
                {needShowTrendLine && <TrendLine initialData={data} />}
                <DataList data={data} />
              </>
            )
          )}
        </Modal.Content>
      </Modal>
    </>
  )
}

export default withLocalization(HistoryResults, localization)
